
import { useRoute } from "vue-router";
import { qualityService } from "@/service";
import { defineComponent, ref } from "vue";
import { ImagePreview } from "vant";
import { Toast } from "vant";
import { useUpload } from "@/composables";

export default defineComponent({
  setup() {
    const detail = ref();
    const route = useRoute();
    const getDetail = async () => {
      const { data } = await qualityService.reform_detail({ id: route.query.id });
      detail.value = data.data;
    };

    const imageShow = ref(false);
    const startPosition = ref(0);

    const reform_desc = ref("");
    const fileList = ref([]);
    const clickImage = (startPosition: number, list: Array<{ photo_file: string }>) => {
      const images = list.map((i: any) => i.photo_file);
      ImagePreview({ images, startPosition });
    };

    const handleSubmit = async () => {
      if (!reform_desc.value) {
        Toast.fail("请输入整改说明");
        return;
      }
      await qualityService.reform_do({
        id: route.query.id,
        reform_desc: reform_desc.value,
        reform_pic_ids: fileList.value.map((file: any) => file.res.id).join(",")
      });
      getDetail();
    };

    getDetail();

    const { upload } = useUpload();

    return {
      detail,
      fileList,
      upload,
      reform_desc,
      imageShow,
      startPosition,
      clickImage,
      handleSubmit
    };
  }
});
